/* registericons.js */

'use strict';
const IconRegistry = require('@gluenetworks/icon_registry').getInstance();

IconRegistry.registerIcon("branding.advanced", require('./rawicons/advanced.icon.png.js'));
IconRegistry.registerIcon("solution.dashboard", require('./rawicons/dashboard.icon.svg'));